module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ANSI_ESD S20.20-2021.12fe7bbf.png";